import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardScoreUnhealthyColored(
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} viewBox="0 0 49 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.9033 3.12305C21.9944 0.0321076 27.0056 0.0321072 30.0967 3.12305L30.6533 3.67871C31.9502 4.97558 33.7089 5.70508 35.543 5.70508H35.6846C40.0561 5.70508 43.5996 9.24861 43.5996 13.6201V13.7617C43.5996 15.5958 44.3291 17.3545 45.626 18.6514L46.1816 19.208C49.2726 22.2991 49.2726 27.3103 46.1816 30.4014L45.626 30.958C44.3291 32.2549 43.5996 34.0136 43.5996 35.8477V35.9893C43.5996 40.3608 40.0561 43.9043 35.6846 43.9043H35.543C33.7089 43.9043 31.9502 44.6338 30.6533 45.9307L30.0967 46.4863C27.0056 49.5773 21.9944 49.5773 18.9033 46.4863L18.3467 45.9307C17.0498 44.6338 15.2911 43.9043 13.457 43.9043H13.3154C8.94392 43.9043 5.40039 40.3608 5.40039 35.9893V35.8477C5.40039 34.0136 4.67089 32.2549 3.37402 30.958L2.81836 30.4014C-0.272579 27.3103 -0.27258 22.2991 2.81836 19.208L3.37402 18.6514C4.67089 17.3545 5.40039 15.5958 5.40039 13.7617V13.6201C5.40039 9.24861 8.94392 5.70508 13.3154 5.70508H13.457C15.2911 5.70508 17.0498 4.97558 18.3467 3.67871L18.9033 3.12305Z"
        fill="url(#paint0_linear_100_6577)"
        stroke="#FFB7B7"
      />
      <path
        d="M13.735 19.8267L23.925 14.2218C24.101 14.125 24.2987 14.0742 24.4996 14.0742C24.7005 14.0742 24.8981 14.125 25.0741 14.2218L35.2642 19.8267C35.4103 19.907 35.5379 20.0171 35.6388 20.1498C35.7397 20.2824 35.8116 20.4348 35.85 20.597C35.8883 20.7592 35.8923 20.9276 35.8615 21.0915C35.8307 21.2553 35.7659 21.4108 35.6713 21.548L25.4806 36.3232C25.371 36.4821 25.2244 36.6119 25.0536 36.7016C24.8827 36.7913 24.6926 36.8381 24.4996 36.8381C24.3066 36.8381 24.1165 36.7913 23.9456 36.7016C23.7747 36.6119 23.6282 36.4821 23.5185 36.3232L13.3279 21.5486C13.2333 21.4114 13.1685 21.2559 13.1377 21.0921C13.1069 20.9282 13.1108 20.7598 13.1492 20.5976C13.1875 20.4354 13.2595 20.283 13.3604 20.1504C13.4613 20.0177 13.5889 19.9076 13.735 19.8273V19.8267Z"
        fill="url(#paint1_linear_100_6577)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100_6577"
          x1="13.925"
          y1="1.30469"
          x2="24.5"
          y2="48.3047"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#F7D0D0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100_6577"
          x1="16.9113"
          y1="16.9197"
          x2="24.4991"
          y2="36.8383"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82090F" />
          <stop offset="1" stopColor="#B0676A" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClipboardScoreUnhealthyColored);
export default ForwardRef;
